import { useRouteLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useTitle } from '../../../../../common/hooks/useTitle.js';
import { myOrdersMsg, omaElisaForEmployeeMsg, t } from '../../../../../common/i18n/index.js';
import { EOECustomerOrderDetails } from '../../../../../components/CustomerOrderDetails/EOECustomerOrderDetails';
import type { UserCustomerOrderLoaderData } from '../../../../../common/loaders';

export const EoeOwnOrderPath = () => {
  const { customerOrder, companyInfo } = useRouteLoaderData('eoe-own-orders') as UserCustomerOrderLoaderData;
  useTitle([t.H6JV(omaElisaForEmployeeMsg), t.EG6F(myOrdersMsg), customerOrder.customerOrderDisplayId]);

  return (
    <EOECustomerOrderDetails
      pathTemplate={paths.EMPLOYEE_OWN_ORDER_ITEM}
      customerOrder={customerOrder}
      deviceSubscriptions={[]}
      breadCrumbPaths={[
        { name: t.H6JV(omaElisaForEmployeeMsg), path: paths.EMPLOYEE_HOME },
        { name: t.EG6F(myOrdersMsg), path: paths.EMPLOYEE_OWN_ORDERS },
        { name: customerOrder.customerOrderDisplayId },
      ]}
      customerType={companyInfo.customerType}
      isApprover={false}
    />
  );
};
